export const ruleEmail = [
    v => !!v || 'E-mail is required',
    v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
];

export const rulePhone = [
    v => !!v || 'Phone is required',
    v => (v && v.length === 10 || v.length === 11) || 'Phone must be 10-11 characters',
    v=> !isNaN(v)||'Must be numbers',
];

export const ruleFullName = [
    v => !!v || 'Full name is required',
    v => (v && v.length >= 4) || 'Full name must be less than 4 characters'
];
